import { useUserSetupStore } from '@sib/auth';
import { useTranslation } from '@sib/i18n';
import { Button } from '@sib/ui';
import { Switch } from '@sib/ui/icons';
import { useDialog } from '../hooks';
import { OrganizationSwitchDialog } from './OrganizationSwitchDialog';

interface OrganizationSwitchProps {
  className?: string;
}

export const OrganizationSwitch = (props: OrganizationSwitchProps) => {
  const { isOpen, handleOpen, handleClose } = useDialog();
  const { hasGlobalAccess } = useUserSetupStore();
  const { t } = useTranslation();

  return hasGlobalAccess ? (
    <>
      <Button onClick={handleOpen} variant="outline" {...props}>
        <Switch className="text-primary h-5 w-5" />
        <span className="hidden sm:block">
          {t('components.organizationSwitch.title')}
        </span>
      </Button>
      <OrganizationSwitchDialog open={isOpen} onClose={handleClose} />
    </>
  ) : null;
};
